
import { NgModule } from '@angular/core';

import { ConsumerCenterEditProvider } from './consumer-center-edit.provider';
import { ConsumerCenterListProvider } from './consumer-center-list.provider';

export * from './consumer-center-edit.provider';
export * from './consumer-center-list.provider';

export {
  ConsumerCenterListProvider,
  ConsumerCenterEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    ConsumerCenterEditProvider,
    ConsumerCenterListProvider
  ]
})
export class ConsumerCenterBackendModule { }
